<ng-container>
  <div class="ag-custom-no-rows-overlay">
    <div class="no-data-div">
      <span><img [src]="'/assets/images/cross-reference.svg'" alt="no-records" /></span>
    </div>
    <ra-ui-empty-state
      id="emptyStateComponent"
      [title]="params['title']"
      [message]="params['content']"
    ></ra-ui-empty-state>
  </div>
</ng-container>
